import { render, staticRenderFns } from "./PhotoUploader.vue?vue&type=template&id=0c0c3662"
import script from "./PhotoUploader.vue?vue&type=script&lang=js"
export * from "./PhotoUploader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports